import React, { useEffect, useRef, useState } from 'react'

import { Box, IconButton } from '@mui/material'
import { MenuIcon } from 'Sui_Icons'
import { Medals, Notifications, ResponsiveMenu, SearchBox, UserProfile } from './compoents'
import logo from 'assets/images/sectorLogos/logo-horizontal.svg'
import { Link } from "react-router-dom";
import { SuiBox } from 'components'
import useHttp from 'hooks/use-http'

export const Header = () => {

    let headerRef = useRef(null)

    //const [offsetFromTop, setOffsetFromTop] = useState(false)

    const { sendRequest: fetchActivityUser } = useHttp();
    const [infoUser, setInfoUser] = useState({})

    useEffect(() => {
        const handleActivityUser = ({ data }) => {
            setInfoUser(data.infoUser)
        }
        fetchActivityUser({ url: `/home/info` }, handleActivityUser)
    }, [])

    // const handleOffsetStateChange = () => {
    //     if (window.scrollY > headerRef.current.offsetTop)
    //         setOffsetFromTop(true)
    //     else
    //         setOffsetFromTop(false)
    // }

    // useEffect(() => {
    //     // document.addEventListener('scroll', handleOffsetStateChange)

    //     return () => {
    //         // document.removeEventListener('scroll', handleOffsetStateChange)
    //     }
    // }, [])


    return (
        <>
            <Box sx={{
                alignItems: 'center',
                background: '#fff',
                boxSizing: 'border-box',
                borderLeft: '1px solid #F1F1F9',
                display: { xs: 'none', lg: 'flex' },
                justifyContent: 'space-between',
                flexDirection: 'row',
                p: 4,
                width: '100%',
            }}>
                <UserProfile infoUser={infoUser} />
                <SearchBox />
                <Box sx={{ display: 'flex' }}>
                    <Medals infoUser={infoUser} />
                    <Notifications infoUser={infoUser} />
                </Box>


            </Box>

            <Box sx={{
                display: { xs: 'flex', lg: 'none' },
                boxShadow: { xs: '0 5px 5px rgb(0 0 0 / 14%)', lg: 'none' },
                flexDirection: 'column',
                transition: 'all ease 0.2s',
                position: { xs: 'sticky', lg: 'relative' },
                top: 0, left: 0,
                background: 'white',
                zIndex: 100,
                width: { xs: '100%', lg: 'unset' },
            }}
                ref={headerRef}

            >

                <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    px: { xs: 2, lg: 0 },
                    py: { xs: 1, lg: 0 },
                    boxSizing: 'border-box',
                    width: '100%',
                    '& img': { width: '100px', height: '30px' }
                }}
                >
                    <ResponsiveMenu infoUser={infoUser} />
                        <SuiBox component={Link} to="/" display={{ xs: 'none', md: 'block' }}> <img src={logo} /></SuiBox>
                    <Notifications infoUser={infoUser} />

                </Box>
                <Box sx={{ px: 2, py: 1 }}>
                    <SearchBox />
                </Box>

            </Box>
        </>
    )
}
